import { SKELETON_CONST } from './Skeleton.enums';
import { Skeleton, radii } from './Skeleton.styles';

import type { SkeletonProps } from './Skeleton.d';

const SkeletonBase = ({
  className,
  count,
  direction,
  duration,
  radius = 'small',
}: SkeletonProps) => (
  <Skeleton.Component data-testid={SKELETON_CONST.TEST_ID}>
    <Skeleton.Skeleton
      borderRadius={radii[radius]}
      className={className}
      count={count}
      direction={direction}
      duration={duration}
    />
  </Skeleton.Component>
);

export default SkeletonBase;
